<template>
    <div id="side-menu" :style="{'background': background, 'max-width': maxWidth}">
        <slot></slot>
    </div>
</template>

<script>
    // import 'bootstrap/js/dist/collapse'
    // import 'simplebar-vue'

    export default {
        props: {
            background: {
                type: String,
                required: false,
                default: '#fff'
            },
            maxWidth: {
                type: String,
                required: false,
                default: '100%'
            },
            overlayColor: {
                type: String,
                required: false,
                default: 'rgba(0,0,0,.5)'
            }
        }
    }
</script>

<style lang="scss">
    // @import '~simplebar-vue/node_modules/simplebar/dist/simplebar.css';

    #side-menu {
        position: fixed;
        display: block;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        min-width: 320px;
        overflow: hidden;
        z-index: 1100;
    }

    .side-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: 1090;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/side-menu/side-menu.vue